import * as Types from '@/types/schema';

import gql from 'graphql-tag';
export type SurveyPerformanceFragment = { entityId: string, id: string, status: Types.PerformanceStatusEnum, progress: number, estimatedTimeSpent?: number | null, type: Types.PerformanceTypeEnum, entityType: Types.PerformanceEntityTypeEnum, isAvailable: boolean, enrolmentInfo?: { dueDate?: string | null } | null };


export type SurveyPerformanceFragmentVariables = Types.Exact<{ [key: string]: never; }>;

export const SurveyPerformanceFragmentDoc = /*#__PURE__*/ gql`
    fragment SurveyPerformance on SurveyPerformanceType {
  entityId
  id
  status
  progress
  estimatedTimeSpent
  type
  entityType
  isAvailable
  progress
  enrolmentInfo {
    dueDate
  }
}
    `;